// src/App.js
// vAPP-HRM-123
// - Menu item Help toegevoegd onder Instellingen
// - Route /help toegevoegd
// - Vacatures en Plaatsingen toegevoegd onder HRM
// - HRM-menu blijft actief bij HRM-routes
// - Handmatig wisselen tussen CRM en HRM blijft mogelijk op dezelfde route
// - Gebruikerslogboek: session_key, heartbeat en logout toegevoegd

import staffiqLogo from "./assets/staffiq-logo.png";
import Login from "./pages/Login";
import { useState, useEffect, useRef } from "react";
import React from "react";
import { BrowserRouter, Routes, Route, NavLink, useLocation } from "react-router-dom";

import Organisaties from "./pages/Organisaties";
import OrganisatieDetail from "./pages/OrganisatieDetail";
import Contactpersonen from "./pages/Contactpersonen";
import NotitiesTaken from "./pages/NotitiesTaken";
import Documenten from "./pages/Documenten";
import Projectbeheer from "./pages/Projectbeheer";
import Facturen from "./pages/Facturen";
import Offertes from "./pages/Offertes";
import Instellingen from "./pages/Instellingen";
import Help from "./pages/Help"; // ✅ nieuw
import Personeel from "./pages/Personeel";
import Aanvragen from "./pages/Aanvragen";
import Vacatures from "./pages/Vacatures";
import Plaatsingen from "./pages/Plaatsingen";
import MatchingPersoneel from "./pages/MatchingPersoneel";
import MatchingRelaties from "./pages/MatchingRelaties";

function Layout({ children, onLogout, currentUser }) {
  const ASIDE_W = 200;
  const MOBILE_BREAKPOINT = 900;

  const role = (currentUser?.role || "user").toLowerCase();
  const isAdmin = role === "admin";

  const [isMobile, setIsMobile] = useState(window.innerWidth <= MOBILE_BREAKPOINT);
  const [menuOpen, setMenuOpen] = useState(false);

  function moduleForPath(pathname) {
    const path = String(pathname || "").toLowerCase();

    const hrmRoutes = [
      "/personeel",
      "/matching-personeel",
      "/matching-relaties",
      "/aanvragen",
      "/vacatures",
      "/plaatsingen",
    ];

    const crmRoutes = [
      "/",
      "/organisaties",
      "/contactpersonen",
      "/projectbeheer",
      "/offertes",
      "/facturen",
      "/instellingen",
    ];

    if (hrmRoutes.some((route) => path === route || path.startsWith(`${route}/`))) return "HRM";
    if (crmRoutes.some((route) => path === route || path.startsWith(`${route}/`))) return "CRM";

    return "";
  }

  const [activeModule, setActiveModule] = useState(() => {
    const routeModule = moduleForPath(window.location.pathname);
    if (routeModule) return routeModule;

    try {
      const saved = sessionStorage.getItem("staffiq_active_module");
      if (saved === "CRM" || saved === "HRM") return saved;
    } catch {}

    return "CRM";
  });

  const location = useLocation();
  const mainRef = useRef(null);

  const isCrmModule = activeModule === "CRM";
  const isHrmModule = activeModule === "HRM";

  function switchModule(moduleName) {
    setActiveModule(moduleName);

    try {
      sessionStorage.setItem("staffiq_active_module", moduleName);
    } catch {}
  }

  useEffect(() => {
    function onResize() {
      const mobile = window.innerWidth <= MOBILE_BREAKPOINT;
      setIsMobile(mobile);

      if (!mobile) {
        setMenuOpen(false);
      }
    }

    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

useEffect(() => {
    if (isMobile) {
      setMenuOpen(false);
    }
  }, [location.pathname, isMobile]);

useEffect(() => {
    // Alleen bij een echte routewisseling de module automatisch zetten.
    // Daardoor kun je op dezelfde pagina handmatig tussen CRM en HRM wisselen.
    const routeModule = moduleForPath(location.pathname);

    if (routeModule) {
      switchModule(routeModule);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  useEffect(() => {
    // Bij wisselen van programma/module altijd terug naar boven.
    // Maar: op smartphone mag het menu NIET sluiten als je alleen wisselt tussen CRM/HRM.
    requestAnimationFrame(() => {
      try {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      } catch {}

      try {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      } catch {}

      try {
        mainRef.current?.scrollTo?.({
          top: 0,
          left: 0,
          behavior: "auto",
        });
      } catch {}
    });
  }, [location.pathname, activeModule]);

  return (
    <div style={{ display: "flex", height: "100dvh", width: "100%", overflow: "hidden", position: "relative" }}>
      {/* MOBIELE TOPBALK */}
      {isMobile && (
        <button
          onClick={() => setMenuOpen(true)}
          aria-label="Menu openen"
          style={{
            position: "fixed",
            top: 12,
            left: 12,
            zIndex: 1200,
            border: "none",
            borderRadius: 10,
            background: "#0f2a3a",
            color: "white",
            padding: "10px 12px",
            fontSize: 22,
            lineHeight: 1,
            cursor: "pointer",
            boxShadow: "0 4px 14px rgba(0,0,0,0.18)",
          }}
        >
          ☰
        </button>
      )}

      {/* MOBIELE OVERLAY ACHTER MENU */}
      {isMobile && menuOpen && (
        <div
          onClick={() => setMenuOpen(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.35)",
            zIndex: 1090,
          }}
        />
      )}

      {/* MENU */}
      <aside
        style={{
          width: ASIDE_W,
          flex: `0 0 ${ASIDE_W}px`,
          padding: 16,
          background: "#0f2a3a",
          color: "white",
          boxSizing: "border-box",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
          height: "100dvh",

          position: isMobile ? "fixed" : "relative",
          top: 0,
          left: 0,
          zIndex: isMobile ? 1100 : "auto",
          transform: isMobile ? (menuOpen ? "translateX(0)" : "translateX(-100%)") : "translateX(0)",
          transition: "transform 0.25s ease",
          boxShadow: isMobile ? "2px 0 16px rgba(0,0,0,0.25)" : "none",
        }}
      >
        {isMobile && (
          <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8 }}>
            <button
              onClick={() => setMenuOpen(false)}
              aria-label="Menu sluiten"
              style={{
                border: "none",
                background: "transparent",
                color: "white",
                fontSize: 28,
                lineHeight: 1,
                cursor: "pointer",
                padding: 0,
              }}
            >
              ×
            </button>
          </div>
        )}

        <div>
          <div style={{ textAlign: "center", marginBottom: 20 }}>
            <img
              src={staffiqLogo}
              alt="StaffIQ"
              style={{
                height: 65,
                marginBottom: 8,
              }}
            />

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "32px 1fr 32px",
                alignItems: "center",
                gap: 4,
                fontWeight: 700,
                fontSize: 20,
              }}
            >
              <button
                type="button"
                onClick={() => switchModule("CRM")}
                disabled={isCrmModule}
                title="Naar CRM"
                style={{
                  border: "none",
                  background: "transparent",
                  color: "white",
                  fontSize: 22,
                  cursor: isCrmModule ? "default" : "pointer",
                  opacity: isCrmModule ? 0 : 1,
                  padding: 0,
                  lineHeight: 1,
                }}
              >
                &lt;
              </button>

              <div>{activeModule}</div>

              <button
                type="button"
                onClick={() => switchModule("HRM")}
                disabled={isHrmModule}
                title="Naar HRM"
                style={{
                  border: "none",
                  background: "transparent",
                  color: "white",
                  fontSize: 22,
                  cursor: isHrmModule ? "default" : "pointer",
                  opacity: isHrmModule ? 0 : 1,
                  padding: 0,
                  lineHeight: 1,
                }}
              >
                &gt;
              </button>
            </div>
          </div>

<nav style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            {isCrmModule && (
              <>
                <NavItem to="/organisaties">
                  <MenuLabel icon="📁" text="Relaties" />
                </NavItem>

                <NavItem to="/contactpersonen">
                  <MenuLabel icon="👥" text="Contactpersonen" />
                </NavItem>

                <NavItem to="/notities-taken">
                  <MenuLabel icon="📝" text="Notities/Taken" />
                </NavItem>

                <NavItem to="/documenten">
                  <MenuLabel icon="🗂" text="Documenten" />
                </NavItem>

                <NavItem to="/projectbeheer">
                  <MenuLabel icon="🧱" text="Projectbeheer" />
                </NavItem>

                <NavItem to="/offertes">
                  <MenuLabel icon="🧾" text="Opdrachten" subText="(Offertes)" />
                </NavItem>

                <NavItem to="/facturen">
                  <MenuLabel icon="📄" text="Facturen" />
                </NavItem>
              </>
            )}

            {isHrmModule && (
              <>
                <NavItem to="/personeel">
                  <MenuLabel icon="👤" text="Personeel" />
                </NavItem>

                <NavItem to="/matching-personeel">
                  <MenuLabel icon="🎯" text="Match Personeel" />
                </NavItem>

                <NavItem to="/matching-relaties">
                  <MenuLabel icon="🎯" text="Match Relaties" />
                </NavItem>

                <NavItem to="/aanvragen">
                  <MenuLabel icon="📋" text="Aanvragen" />
                </NavItem>

                <NavItem to="/vacatures">
                  <MenuLabel icon="📌" text="Vacatures" />
                </NavItem>

                <NavItem to="/plaatsingen">
                  <MenuLabel icon="🤝" text="Plaatsingen" />
                </NavItem>

                <NavItem to="/notities-taken">
                  <MenuLabel icon="📝" text="Notities/Taken" />
                </NavItem>

                <NavItem to="/documenten">
                  <MenuLabel icon="🗂" text="Documenten" />
                </NavItem>
              </>
            )}
          </nav>

        </div>

<div style={{ marginTop: 6, display: "flex", flexDirection: "column", gap: 6 }}>
<nav style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            <NavItem to="/help">
              <MenuLabel icon="❓" text="Help" />
            </NavItem>

            {isCrmModule && isAdmin && (
              <NavItem to="/instellingen">
                <MenuLabel icon="⚙" text="Instellingen" />
              </NavItem>
            )}
          </nav>

<button
  onClick={() => {
    setMenuOpen(false);
    onLogout();
  }}
  style={{
    color: "white",
    textDecoration: "none",
    padding: "6px 12px",
    borderRadius: 6,
    background: "transparent",
    display: "block",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign: "left",
    border: "none",
    cursor: "pointer",
    font: "inherit",
  }}
            title="Uitloggen"
          >
            🚪 Uitloggen
          </button>
        </div>

      </aside>

      <main
        ref={mainRef}
        style={{
          flex: "1 1 auto",
          minWidth: 0,
          padding: isMobile ? "56px 12px 12px 12px" : 24,
          background: "#f6f6f6",
          boxSizing: "border-box",
          height: "100dvh",
          overflowY: "auto",
          marginLeft: isMobile ? 0 : 0,
          width: "100%",
        }}
      >
        {children}
      </main>
    </div>
  );
}

function MenuLabel({ icon, text, subText }) {
  return (
    <span
      style={{
        display: "grid",
        gridTemplateColumns: "26px 1fr",
        alignItems: "start",
        columnGap: 0,
        lineHeight: 1.05,
      }}
    >
      <span style={{ width: 26, textAlign: "left" }}>{icon}</span>
      <span style={{ display: "flex", flexDirection: "column" }}>
        <span>{text}</span>
        {subText && (
          <span style={{ fontSize: 12, opacity: 0.7 }}>
            {subText}
          </span>
        )}
      </span>
    </span>
  );
}

function NavItem({ to, children }) {
  return (
    <NavLink
      to={to}
      style={({ isActive }) => ({
        color: "white",
        textDecoration: "none",
        padding: "10px 12px",
        borderRadius: 8,
        background: isActive ? "#1e4e6a" : "transparent",
        display: "block",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        fontSize: 16,
      })}
      title={typeof children === "string" ? children : undefined}
    >
      {children}
    </NavLink>
  );
}

// -------------------- ACTIVITY LOG HELPERS --------------------

function getStoredUserForActivity() {
  try {
    const raw =
      sessionStorage.getItem("user") ||
      localStorage.getItem("user") ||
      "";

    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function getActivitySessionKey() {
  const user = getStoredUserForActivity();

  return (
    sessionStorage.getItem("session_key") ||
    localStorage.getItem("session_key") ||
    user?.session_key ||
    ""
  );
}

function getActivityTenant() {
  const user = getStoredUserForActivity();

  return (
    sessionStorage.getItem("tenant") ||
    localStorage.getItem("tenant") ||
    user?.tenant ||
    "demo"
  );
}

function buildActivityHeaders() {
  const user = getStoredUserForActivity();
  const sessionKey = getActivitySessionKey();

  const headers = {};

  if (sessionKey) headers["x-session-key"] = sessionKey;
  if (getActivityTenant()) headers["x-tenant"] = getActivityTenant();

  if (user?.id) headers["x-staffiq-user-id"] = String(user.id);
  if (user?.email) headers["x-staffiq-user-email"] = String(user.email);
  if (user?.display_name || user?.name) {
    headers["x-staffiq-user-name"] = String(user.display_name || user.name);
  }
  if (user?.role) headers["x-role"] = String(user.role);

  return headers;
}

async function sendActivityHeartbeat() {
  const sessionKey = getActivitySessionKey();
  if (!sessionKey) return;

  try {
    await fetch("/api/activity-log/heartbeat", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...buildActivityHeaders(),
      },
      body: JSON.stringify({
        session_key: sessionKey,
      }),
    });
  } catch {
    // bewust stil: logboek mag het systeem nooit blokkeren
  }
}

async function sendActivityLogout() {
  const sessionKey = getActivitySessionKey();
  if (!sessionKey) return;

  try {
    await fetch("/api/activity-log/logout", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...buildActivityHeaders(),
      },
      body: JSON.stringify({
        session_key: sessionKey,
        reason: "logout",
      }),
    });
  } catch {
    // bewust stil: uitloggen mag nooit blokkeren
  }
}

export default function App() {

const [isLoggedIn, setIsLoggedIn] = useState(false);
const [currentUser, setCurrentUser] = useState(null);

useEffect(() => {
  const token = sessionStorage.getItem("token");
  const rawUser = sessionStorage.getItem("user");

  if (token) setIsLoggedIn(true);

  try {
    const parsedUser = rawUser ? JSON.parse(rawUser) : null;

    if (parsedUser?.session_key) {
      sessionStorage.setItem("session_key", parsedUser.session_key);
      localStorage.setItem("session_key", parsedUser.session_key);
    }

    setCurrentUser(parsedUser);
  } catch {
    setCurrentUser(null);
  }
}, []);

useEffect(() => {
  if (!isLoggedIn) return;

  // Bij starten direct één heartbeat, daarna elke 2 minuten.
  sendActivityHeartbeat();

  const timer = window.setInterval(() => {
    sendActivityHeartbeat();
  }, 120000);

  return () => {
    window.clearInterval(timer);
  };
}, [isLoggedIn, currentUser?.id]);

useEffect(() => {
  if (!isLoggedIn) return;

  // Deze patch zorgt dat toekomstige API-calls automatisch
  // gebruiker + sessie meesturen naar server.js.
  // GET blijft op de server buiten het gewone logboek,
  // dus dit geeft nauwelijks extra ballast.
  const originalFetch = window.fetch;

  if (window.__staffiqActivityFetchPatched) return;

  window.__staffiqActivityFetchPatched = true;

  window.fetch = (input, init = {}) => {
    try {
      const url =
        typeof input === "string"
          ? input
          : input?.url || "";

      const shouldAddHeaders =
        String(url || "").startsWith("/api/") ||
        String(url || "").includes("localhost:3001/api/");

      if (!shouldAddHeaders) {
        return originalFetch(input, init);
      }

      const existingHeaders = init?.headers || {};

      const mergedHeaders = {
        ...(existingHeaders || {}),
        ...buildActivityHeaders(),
      };

      return originalFetch(input, {
        ...init,
        headers: mergedHeaders,
      });
    } catch {
      return originalFetch(input, init);
    }
  };

  return () => {
    try {
      window.fetch = originalFetch;
      window.__staffiqActivityFetchPatched = false;
    } catch {}
  };
}, [isLoggedIn, currentUser?.id]);

const handleLogin = () => {
  setIsLoggedIn(true);

  try {
    const rawUser = sessionStorage.getItem("user");
    const parsedUser = rawUser ? JSON.parse(rawUser) : null;

    if (parsedUser?.session_key) {
      sessionStorage.setItem("session_key", parsedUser.session_key);
      localStorage.setItem("session_key", parsedUser.session_key);
    }

    setCurrentUser(parsedUser);
  } catch {
    setCurrentUser(null);
  }
};

const handleLogout = async () => {
  await sendActivityLogout();

  sessionStorage.removeItem("token");
  sessionStorage.removeItem("tenant");
  sessionStorage.removeItem("user");
  sessionStorage.removeItem("session_key");

  localStorage.removeItem("token");
  localStorage.removeItem("tenant");
  localStorage.removeItem("user");
  localStorage.removeItem("session_key");

  setIsLoggedIn(false);
  setCurrentUser(null);
};

if (!isLoggedIn) {
  return <Login onLogin={handleLogin} />;
}

return (
  <>
    <BrowserRouter>
      <Layout onLogout={handleLogout} currentUser={currentUser}>
        <Routes>
          <Route path="/" element={<Organisaties />} />
          <Route path="/organisaties" element={<Organisaties />} />
          <Route path="/organisaties/:id" element={<OrganisatieDetail />} />
          <Route path="/contactpersonen" element={<Contactpersonen />} />
          <Route path="/notities-taken" element={<NotitiesTaken />} />
          <Route path="/documenten" element={<Documenten />} />
          <Route path="/projectbeheer" element={<Projectbeheer />} />
          <Route path="/offertes" element={<Offertes />} />
          <Route path="/facturen" element={<Facturen />} />
          <Route
            path="/instellingen"
            element={
              (currentUser?.role || "").toLowerCase() === "admin"
                ? <Instellingen />
                : <Help />
            }
          />
          <Route path="/personeel" element={<Personeel />} />
          <Route path="/matching-personeel" element={<MatchingPersoneel />} />
          <Route path="/matching-relaties" element={<MatchingRelaties />} />
          <Route path="/aanvragen" element={<Aanvragen />} />
          <Route path="/vacatures" element={<Vacatures />} />
          <Route path="/plaatsingen" element={<Plaatsingen />} />
          <Route path="/help" element={<Help />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  </>
);
}